<template>
  <gj-tooltip
      :popper-class="popperClass"
      :style="{marginLeft: `${left}`, fontSize,height:fontSize}"
      v-bind="$attrs"
      style="line-height: 1;">
    <slot name="icon">
      <gj-icon iconfont="iconbangzhu" class="gj-help--icon" :style="{height:fontSize}"></gj-icon>
    </slot>
    <template #content>
      <slot v-if="list">
        <div v-for="(i,index) in list" :key="index">{{i}}</div>
      </slot>
     <span v-else><slot></slot></span>
    </template>
  </gj-tooltip>
</template>

<script>
  export default {
    name: "gj-help",
    props: {
      popperClass: {
        type: String,
        default: '',
      },
      left: {
        type: String,
        default: '0px'
      },
      fontSize: {
        type: String,
        default: '14px'
      },
      list:null
    }
  }
</script>

<style scoped>
  .gj-help--icon {
    color: #666666;
    cursor: pointer;
    display: inline-block;
  }
</style>
